import React, { useMemo } from "react";

import { ButtonLayout, ButtonLink, ButtonPrimary, Grid, GridItem, IconWarningLight, skinVars, Text2, Text3, useScreenSize } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import { FeedbackContainer } from "../../../components/FeedbackContainer";
import { ScreenResponsive } from "../../../components/organisms";
import { useNavigateCustom } from "../../../hooks";
import { strings } from "../../../localization";

const { keyPixIncorrect } = strings.pages.errorCustomUnavailable;
const { toGoOut } = strings.components.buttons;

const ErrorPixKeyIncorrect: React.FC = observer(() => {
	const navigation = useNavigateCustom();
	const { isDesktopOrBigger } = useScreenSize();

	const handleNavigate = (): void => {
		navigation("/withdraw-payment-info");
	};

	const onHandleToGoOut = (): void => {
		navigation("/");
	};

	// retorna buttonLink
	const renderButtonLink = useMemo(() => (
		<ButtonLink onPress={onHandleToGoOut} disabled={false}>
			{isDesktopOrBigger ? (
				<Text3 medium color={skinVars.colors.textLink}>
					{toGoOut}
				</Text3>
			) : (
				<Text2 medium color={skinVars.colors.textLink}>
					{toGoOut}
				</Text2>
			)}
		</ButtonLink>
	), [isDesktopOrBigger]);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<GridItem>
					<FeedbackContainer
						icon={<IconWarningLight size={64} color={skinVars.colors.controlError} />}
						title={keyPixIncorrect.title}
						description={keyPixIncorrect.description}
					>
						<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
							<>
								{/* renderiza botão de link apenas para desktop */}
								{isDesktopOrBigger && renderButtonLink}

								<ButtonPrimary
									onPress={handleNavigate}
									disabled={false}
									style={{ width: isDesktopOrBigger ? "auto" : "100%" }}
								>
									<Text3 medium color={skinVars.colors.textButtonPrimary}>
										{keyPixIncorrect.buttonPrimary}
									</Text3>
								</ButtonPrimary>

								{/* renderiza botão de link apenas para mobile */}
								{!isDesktopOrBigger && renderButtonLink}
							</>
						</ButtonLayout>
					</FeedbackContainer>
				</GridItem>
			</Grid>
		</ScreenResponsive>
	);
});

export default ErrorPixKeyIncorrect;
